import { render, staticRenderFns } from "./DeclineAllocationsAction.vue?vue&type=template&id=22b127fa&"
import script from "./DeclineAllocationsAction.vue?vue&type=script&lang=js&"
export * from "./DeclineAllocationsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports